module.exports = __webpack_public_path__ + "static/media/drop-bg.3393c1f9.png";